export default __webpack_public_path__ + "static/media/edit.ff0fcb31.svg";